import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteLesson({ lessonId, lessonTitle, onDeleted, triggerButtonProps = {}, }) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            await axios.delete(api_endpoint + `/lesson/${lessonId}`, reqConfig)
            toast.success(`Lesson "${lessonTitle}" deleted successfully!`)
            setOpen(false)
            if (onDeleted) onDeleted(lessonId)
        } catch (error) {
            toast.error(`Failed to delete lesson "${lessonTitle}".`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {/* <span
                className="text-red  hover:underline cursor-pointer"
                onClick={() => setOpen(true)}
            >
                Delete Lesson
            </span> */}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    <Button
                        variant="outline"
                        size="sm"
                        className="border-(--neutral-300) text-(--neutral-900) bg-(--surface-panel) hover:bg-(--neutral-100) dark:hover:bg-(--neutral-200)"
                        {...triggerButtonProps}
                    >
                        {/* <Edit className="w-4 h-4 mr-2" /> */}
                        Delete Lesson
                    </Button>
                </DialogTrigger>
                <DialogContent className="max-w-md h-auto bg-(--surface-panel) text-(--neutral-900)">
                    <DialogHeader>
                        <DialogTitle className="font-heading text-(--neutral-900)">Delete Lesson</DialogTitle>
                    </DialogHeader>
                    <div className="font-body text-(--neutral-700)">
                        Are you sure you want to delete the lesson <b>{lessonTitle}</b> ? This action cannot be undone.
                    </div>
                    <DialogFooter>
                        <DialogClose asChild>
                            <Button 
                                variant="outline" 
                                onClick={() => setOpen(false)} 
                                disabled={loading} 
                                className="">
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button
                            variant=""
                            onClick={handleDelete}
                            disabled={loading}
                            className=""
                        >
                            {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="var(--neutral-50)" />
                                </span>
                            ) : (
                                "Delete"
                            )}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}